// extracted by mini-css-extract-plugin
export default {"fixedTitle":"CardTitle_fixedTitle__NWb1A"};